var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTrendDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 216V392C576 405.25 565.25 416 552 416H376C362.75 416 352 405.25 352 392S362.75 368 376 368H494.062L320 193.938L208.969 304.969C204.281 309.656 198.141 312 192 312S179.719 309.656 175.031 304.969L7.031 136.969C2.344 132.281 0 126.141 0 120C0 106.291 11.21 96 24 96C30.141 96 36.281 98.344 40.969 103.031L192 254.062L303.031 143.031C307.719 138.344 313.859 136 320 136S332.281 138.344 336.969 143.031L528 334.062V216C528 202.75 538.75 192 552 192S576 202.75 576 216Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTrendDown);
export default __webpack_public_path__ + "static/media/arrow-trend-down.92b7c5bb522d4b1930e9d197d4856e46.svg";
export { ForwardRef as ReactComponent };